"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconButton = void 0;

var _swatches = require("../swatches");

var iconButton = {
  background: _swatches.monochrome.transparent,
  backgroundHover: _swatches.monochrome.light,
  backgroundPressed: _swatches.monochrome.light,
  backgroundDisabled: _swatches.monochrome.transparent,
  border: _swatches.monochrome.transparent,
  borderHover: _swatches.monochrome.transparent,
  borderPressed: _swatches.monochrome.transparent,
  borderDisabled: _swatches.monochrome.transparent,
  text: _swatches.monochrome.mediumDark,
  textHover: _swatches.monochrome.dark,
  textPressed: _swatches.monochrome.dark,
  textDisabled: _swatches.monochrome.mediumDark,
  opacity: 1,
  opacityHover: 1,
  opacityPressed: 1,
  opacityDisabled: 0.5
};
exports.iconButton = iconButton;
//# sourceMappingURL=iconButton.js.map